/*eslint-disable */
import ActivityInfo from './ActivityInfo';

export default ActivityInfo;
